import React from "react";
import Participants from "./Participants";
import ParticipantsLabel from "./ParticipantsLabel";

const ParticipantsSection = () => {
  return (
    <div className="participants_popup_container open">
      <div className="fixed-top">
        <p className="popup-title">People</p>
        <span
          className="close-btn"
          onClick={() => {
            // Close the popup by dispatching action
            const event = new CustomEvent('closeParticipantsPopup');
            window.dispatchEvent(event);
          }}
        >
          ×
        </span>
      </div>
      <div className="participants_popup_container2">
        <ParticipantsLabel title="Participants" />
        <Participants />
      </div>
    </div>
  );
};

export default ParticipantsSection;